import { useFetchCommonApiQuery } from "@/api/services/commonApi/CommonApi";

const useFetchCommonData = (endpoint, options = {}) => {
  const { skip, ...params } = options;
  return useFetchCommonApiQuery({ endpoint, params }, { skip });
};

export default useFetchCommonData;
  
  